var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.87749C12.6095 6.7378 12.4194 6.65939 12.2213 6.65939C12.0231 6.65939 11.833 6.7378 11.6925 6.87749L9.00002 9.53249L6.34502 6.87749C6.2045 6.7378 6.01441 6.65939 5.81627 6.65939C5.61813 6.65939 5.42804 6.7378 5.28752 6.87749C5.21723 6.94721 5.16143 7.03016 5.12335 7.12156C5.08528 7.21295 5.06567 7.31098 5.06567 7.40999C5.06567 7.509 5.08528 7.60703 5.12335 7.69842C5.16143 7.78981 5.21723 7.87277 5.28752 7.94249L8.46752 11.1225C8.53724 11.1928 8.6202 11.2486 8.71159 11.2867C8.80298 11.3247 8.90101 11.3443 9.00002 11.3443C9.09903 11.3443 9.19706 11.3247 9.28846 11.2867C9.37985 11.2486 9.4628 11.1928 9.53252 11.1225L12.75 7.94249C12.8203 7.87277 12.8761 7.78981 12.9142 7.69842C12.9523 7.60703 12.9719 7.509 12.9719 7.40999C12.9719 7.31098 12.9523 7.21295 12.9142 7.12156C12.8761 7.03016 12.8203 6.94721 12.75 6.87749Z",
    fill: "#899093"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowDown.dab194ad67d003526311189c05254cf0.svg";